import { Box, Chip, Switch, Typography } from "@mui/material"
import { useSnackbar } from "notistack"
import { useRefresh } from "lib/@hooks/useRefresh"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/if"
import { saveClientCopVersion } from "./controller/save-client-cop-version.controller"

export function CopClientRow({ client }) {
    const { codeOfPracticeId } = useBoundContext()
    const { enqueueSnackbar } = useSnackbar()
    const refresh = useRefresh()
    const isAssigned = client.isAssignedToCurrentCop
    const hasOtherCop = !isAssigned && !!client.activeCopId

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                py: 0.75,
                px: 1,
                borderBottom: 1,
                borderColor: "divider",
                "&:hover": { bgcolor: "action.hover" },
            }}
        >
            <Switch size="small" checked={isAssigned} onChange={handleToggle} />
            <Typography variant="body2" sx={{ flex: 1, ml: 1 }}>
                {client.name}
            </Typography>
            <If value={hasOtherCop}>
                <Chip label="Other CoP" size="small" color="warning" variant="outlined" />
            </If>
        </Box>
    )

    async function handleToggle() {
        try {
            await saveClientCopVersion({
                clientId: client._id,
                codeOfPracticeId: isAssigned ? null : codeOfPracticeId,
            })
            refresh()
        } catch (e) {
            enqueueSnackbar(`Failed to update: ${e.message}`, { variant: "error" })
        }
    }
}
